module.exports = __webpack_public_path__ + "img/1386870428.301e4702.jpg";